import React from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'

const Projects = () => {
    const { pathname: p } = useLocation()

    return (
        <div id="project" className="my-20 max-w-7xl mx-auto px-10">
            <h2 className="text-4xl text-warning text-center font-bold tracking-wider">My Projects</h2>
            <div className="flex justify-center gap-3 lg:gap-5 mt-6">
                <Link
                    className={`btn btn-outline btn-sm hover:btn-secondary w-16 lg:w-28 ${
                        p === '/' && 'btn-active text-primary'
                    }`}
                    to="/"
                >
                    All
                </Link>
                <Link
                    className={`btn btn-outline btn-sm hover:btn-secondary w-16 lg:w-28 ${
                        p === '/react' && 'btn-active text-primary'
                    }`}
                    to="/react"
                >
                    React
                </Link>
                <Link
                    className={`btn btn-outline btn-sm hover:btn-secondary w-16 lg:w-28 ${
                        p === '/redux' && 'btn-active text-primary'
                    }`}
                    to="/redux"
                >
                    Redux
                </Link>
                <Link
                    className={`btn btn-outline btn-sm hover:btn-secondary w-24 lg:w-28 ${
                        p === '/javascript' && 'btn-active text-primary'
                    }`}
                    to="/javascript"
                >
                    JavaScript
                </Link>
            </div>
            <Outlet />
        </div>
    )
}

export default Projects
